export default "__VITE_ASSET__DqK12tbw__"